// "Jarvis learned today" — extracted facts from email that landed in the
// knowledge base. Read-only here; full memory management lives elsewhere.

import { useState } from 'react'
import { JarvisCard } from '@/components/JarvisCard'
import type { EmailFactItem } from '@/types'

interface Props {
  facts: EmailFactItem[]
}

export function EmailLearnedSection({ facts }: Props) {
  const [showAll, setShowAll] = useState(false)
  if (facts.length === 0) return null

  const visible = showAll ? facts : facts.slice(0, 4)

  return (
    <JarvisCard>
      <h2 className="text-xs uppercase tracking-widest text-jarvis-muted mb-2">
        Jarvis learned today · {facts.length} fact{facts.length === 1 ? '' : 's'}
      </h2>
      <p className="text-xs text-jarvis-muted mb-3">
        Added to your knowledge base. When you call Jarvis later, it knows
        these.
      </p>
      <ul className="space-y-2 text-sm">
        {visible.map((f) => (
          <li key={f.id} className="flex items-start gap-2">
            <span className="text-jarvis-blue mt-0.5">•</span>
            <div>
              <div className="text-jarvis-text">{f.content}</div>
              <div className="text-xs text-jarvis-muted mt-0.5">
                from "{f.subject}"
              </div>
            </div>
          </li>
        ))}
      </ul>
      {!showAll && facts.length > 4 && (
        <button
          onClick={() => setShowAll(true)}
          className="text-xs uppercase tracking-wider text-jarvis-blue hover:text-jarvis-blue-bright mt-3"
        >
          + {facts.length - 4} more
        </button>
      )}
    </JarvisCard>
  )
}
